import React from 'react';
import {connect} from 'react-redux';
import SideNav from 'components/layout/SideNav';
import MobileNav from 'components/layout/MobileNav'
import HeaderNav from 'components/layout/HeaderNav';
import Footer from 'components/layout/Footer';
import AppRouter from 'components/app/router/AppRouter';
import {Button, Layout, notification} from "antd";
import {SIDE_NAV_COLLAPSED_WIDTH, SIDE_NAV_WIDTH,} from 'model/constants/ThemeConstant';
import actions from "redux/actions";
import IModule from "../../model/interface/dataStorage/IModule";
import IBaseProps from "../../model/interface/IBaseProps";
import {ReloadOutlined} from "@ant-design/icons";
import IScreen from "../../model/interface/ui/IScreen";
import ISettings from "../../model/interface/ui/ISettings";
import Utils from "../../utils";
import {load, reLoad, startLoading} from "../../redux/actions/Setup";
import PushNotificationsService from "../../model/service/push-notifications/PushNotificationsService";
import {IAppState} from "../../redux/store";
import PopupModal from "./ui/PopupModal";
import selectors from "../../redux/selectors";
import SettingsService from "../../model/service/SettingsService";


const {Content} = Layout;

interface IProps extends IBaseProps {
    navCollapsed: boolean,
    margin: string,
    fontSize: string,
    tableSize: string,
    navType: string,
    locale: string,
    loaded: boolean,
    loading: boolean,
    modules: IModule[],
    load: () => { type: string; },
    reLoad: () => { type: string; },
    loadNotifications: () => void,
    loadStreamEvents: () => void
    reloadNotifications: () => void
    onIsMobileChange: (toggle: boolean) => void,
    startLoading: () => void,
    settings: ISettings
    headerHeight?: number
    loginPopups?: string[]
    setupUpdate?: string,
    versionUpdate?: string,
    getText: (code: string, fallBack?: string) => string
}

interface IState {
    interval: NodeJS.Timeout | null
    screen: IScreen
    screenTimeout: null | NodeJS.Timeout
    reloadButtonTimeout: null | NodeJS.Timeout
    initialized: boolean
}

class AppLayout extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props)
        this.state = {
            interval: null,
            initialized: false,
            screen: Utils.getScreenInfo(),
            screenTimeout: null,
            reloadButtonTimeout: null
        }
    }

    componentDidUpdate(prevProps: Readonly<IProps>) {
        const {loaded, setupUpdate, versionUpdate, getText, reLoad} = this.props
        if (loaded !== prevProps.loaded) {
            if (loaded && !this.state.initialized) {
                //this.props.loadNotifications()
                this.props.loadStreamEvents()
                PushNotificationsService.askPermission().then()
                this.setState({
                    initialized: true
                })
            }
        }
        if (setupUpdate && prevProps.setupUpdate && setupUpdate !== prevProps.setupUpdate && loaded && SettingsService.getValue('ui', 'setupUpdate') === 'alert') {
            notification.close(prevProps.setupUpdate)
            notification.info({
                key: setupUpdate,
                message: getText('system.ui.setup-update', 'Aktualizace nastavení'),
                description:
                    <>
                        {getText('system.ui.setup-update.description', 'Byla zjištěna nová aktualizace nastavení, která bude automaticky stažena při vaší příští návštěvě aplikace, nyní si ji můžete stáhnout zde.')}
                        <div className={"mt-2"}>
                            <Button onClick={() => {
                                notification.close(setupUpdate);
                                reLoad()
                            }} size={"small"}
                                    style={{fontSize: 12}}><ReloadOutlined/> {getText('system.ui.setup-update.update', 'Aktualizovat')}
                            </Button>
                        </div>
                    </>,
                placement: 'bottomRight',
                duration: 0
            });
        }
        if (versionUpdate && prevProps.versionUpdate && versionUpdate !== prevProps.versionUpdate && loaded && SettingsService.getValue('ui', 'versionUpdate') === 'alert') {
            notification.close(prevProps.versionUpdate)
            notification.info({
                key: versionUpdate,
                message: getText('system.ui.version-update', 'Nová verze aplikace'),
                description:
                    <>
                        {getText('system.ui.version-update.description', 'Byla zjištěna nová verze aplikace, která bude automaticky stažena při vaší příští návštěvě aplikace, nyní si ji můžete stáhnout obnovením stránky.')}
                        <div className={"mt-2"}>
                            <Button onClick={() => {
                                notification.close(versionUpdate);
                                this.reload()
                            }} size={"small"}
                                    style={{fontSize: 12}}><ReloadOutlined/> {getText('system.ui.version-update.update', 'Obnovit stránku')}
                            </Button>
                        </div>
                    </>,
                placement: 'bottomRight',
                duration: 0
            });
        }
    }

    componentDidMount() {
        const {loaded, loading, load, onIsMobileChange} = this.props
        if (!loaded && !loading) {
            load()
        }
        onIsMobileChange(this.state.screen.isMobile)


        // const token = localStorage.getItem(AUTH_TOKEN)
        // let domain = ''
        // if (['development', 'dev'].includes(process.env.REACT_APP_ENV as string)){
        //     domain = 'ws://' + (new URL(process.env.REACT_APP_BASE_URL || '')).hostname
        // } else {
        //     domain = 'wss://' + (new URL(process.env.REACT_APP_BASE_URL || '')).hostname
        // }
        // console.log(domain)
        // const socket = new WebSocket(domain  + ':8080' + (token ? ['?token=' + token] : undefined) );
        //
        // socket.addEventListener('open', function (event) {
        //     // socket.send(JSON.stringify({ type: 'auth', token: localStorage.getItem(AUTH_TOKEN) }));
        //     console.log('Connected to WebSocket server');
        // });
        //
        // socket.addEventListener('message', function (event) {
        //     switch (event.data){
        //         case 'update_notification': reloadNotifications(); break;
        //         case 'test': console.log(event.data); break;
        //         default: console.log(event.data)
        //     };
        //
        //     // Update the UI with the notification
        // });
        //
        // socket.addEventListener('close',  (event) => {
        //     setInterval(() => reloadNotifications(), 30000)
        //     console.log('Disconnected from WebSocket server');
        // });

        Utils.registerScreenUpdate(
            (screenTimeout: NodeJS.Timeout) => this.setState({screenTimeout}),
            (screen: IScreen) => this.setState({screen}, () => onIsMobileChange(screen.isMobile)),
        )
    }

    //
    // componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any) {
    //     // alert('A:'+  prevProps.loading)
    //     this.setState({reloadButtonTimeout: setTimeout(() => {
    //         alert('X')
    //         // this.setState({reloadAvailable: true, reloadButtonTimeout: null})
    //     }, 3000)});
    //     if(prevProps.loading && !prevState.reloadButtonTimeout) {
    //     }
    // }

    reload() {
        this.props.startLoading()
        window.location.href = window.location.pathname + "?" + new Date().getTime();
    }

    render() {
        const {loaded, match, history, settings, margin, fontSize, tableSize, headerHeight, loginPopups, getText} = this.props
        const {screen} = this.state
        const {isMobile} = screen
        let layoutGutter = this.props.navCollapsed ? SIDE_NAV_COLLAPSED_WIDTH : SIDE_NAV_WIDTH

        if (isMobile) {
            layoutGutter = 0;
        }

        return (
            <div>
                {loaded && (
                    <Layout>
                        <HeaderNav isMobile={isMobile} history={history} match={match} settings={settings} getText={getText}/>
                        <Layout
                            className={"app-container app-container-margin-" + margin + " app-container-font-size-" + fontSize + " app-container-table-" + tableSize}>
                            {!isMobile ?
                                <SideNav settings={settings} match={match}
                                         history={history} headerHeight={headerHeight}/> : null}
                            <Layout id={'app-layout'} className="app-layout justify-content-between"
                                    style={{marginLeft: layoutGutter}}>
                                <div className={'app-content flex-grow-1'} style={{
                                    marginTop: headerHeight + 'px',
                                }}>
                                    <Content className={'h-100'}>
                                        <AppRouter match={match} history={history}/>
                                    </Content>
                                </div>
                                <Footer settings={settings}/>
                            </Layout>
                        </Layout>
                        {isMobile && (<MobileNav history={history} match={match} projectSettings={settings}/>)}
                        <PopupModal stack={loginPopups}/>
                    </Layout>
                )}
            </div>
        )
    }
}

const mapStateToProps = (state: IAppState) => {
    const {loaded, loading, modules, settings, loginPopups} = state.setup
    const {navCollapsed, navType, locale, margin, fontSize, tableSize, headerHeight} = state.theme;

    return {
        navCollapsed,
        navType,
        locale,
        loaded,
        loading,
        modules,
        margin,
        fontSize,
        tableSize,
        headerHeight,
        settings,
        loginPopups,
        setupUpdate: state.streamEvents.setup,
        versionUpdate: state.streamEvents.version,
        getText: (code: string, fallback?: string) => selectors.dictionary.getMessage(state, code, fallback)
    }
};

const mapDispatchToProps = {
    load: () => load(),
    reLoad: () => reLoad(),
    startLoading,
    loadNotifications: actions.notifications.load,
    loadStreamEvents: actions.streamEvents.load,
    reloadNotifications: actions.notifications.reload,
    onIsMobileChange: actions.theme.onIsMobileChange
}

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(AppLayout));
